
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
    setup() {
        const router=useRouter();
        const colorChange = (i: number) => {
            if(i==4) return router.push("/color");
            window.document.documentElement.setAttribute(
                "data-ming",
                `theme${i}`
            );
            //通过本地缓存进行处理刷新
            window.localStorage.setItem("theme", `theme${i}`);
        };
        const goEvent=()=>{
            router.push("/contact");
        };
        return { colorChange ,goEvent};
    },
});
